import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { BookOpen, BookMarked, GraduationCap, Brain, Heart } from 'lucide-react';

export default function Ilm({ user }) {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const lang = i18n.language;

  const categories = [
    {
      icon: BookOpen,
      title: lang === 'hr' ? "Kur'an" : "Qur'an",
      description: lang === 'hr' ? "Čitaj i slušaj Kur'an sa prijevodima" : 'Read and listen to the Quran with translations',
      path: '/quran-reader',
      color: 'from-emerald-500 to-teal-600',
      bg: 'bg-emerald-50',
      border: 'border-emerald-200',
    },
    {
      icon: Brain,
      title: lang === 'hr' ? 'Hifz' : 'Hifz (Memorization)',
      description: lang === 'hr' ? 'Memoriziraj ajete, postavi ponavljanja i prati napredak' : 'Memorize verses, set repeat loops, track progress',
      path: '/hifz',
      color: 'from-violet-500 to-purple-600',
      bg: 'bg-violet-50',
      border: 'border-violet-200',
    },
    {
      icon: BookMarked,
      title: lang === 'hr' ? 'Hadisi' : 'Hadith',
      description: lang === 'hr' ? 'Pregledaj zbirke hadisa' : 'Browse hadith collections',
      path: '/hadith',
      color: 'from-amber-500 to-orange-500',
      bg: 'bg-amber-50',
      border: 'border-amber-200',
    },
    {
      icon: Heart,
      title: lang === 'hr' ? 'Zbirka Dova' : 'Dua Collection',
      description: lang === 'hr' ? 'Dove za svaku priliku s favoritima' : 'Supplications for every occasion with favorites',
      path: '/dua',
      color: 'from-rose-500 to-pink-600',
      bg: 'bg-rose-50',
      border: 'border-rose-200',
    },
  ];

  return (
    <Layout user={user}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 md:py-12">
        <div className="mb-10">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-2xl flex items-center justify-center shadow-md">
              <GraduationCap className="w-6 h-6 text-white" />
            </div>
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-[#292524]">
              Ilm
            </h1>
          </div>
          <p className="text-[#57534E] font-body ml-15 mt-1">
            {lang === 'hr'
              ? 'Znanje je ibadet - uči, čitaj i razmišljaj'
              : 'Knowledge is worship - learn, read and reflect'}
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3 sm:gap-5">
          {categories.map((cat, idx) => (
            <button
              key={idx}
              onClick={() => navigate(cat.path)}
              data-testid={`ilm-card-${cat.path.slice(1)}`}
              className={`group ${cat.bg} border ${cat.border} rounded-2xl p-4 sm:p-7 text-left hover:shadow-lg transition-all duration-300 hover:-translate-y-1 active:scale-98`}
            >
              <div className={`w-10 h-10 sm:w-14 sm:h-14 bg-gradient-to-br ${cat.color} rounded-xl flex items-center justify-center mb-3 sm:mb-5 shadow-md group-hover:scale-110 transition-transform duration-300`}>
                <cat.icon className="w-5 h-5 sm:w-7 sm:h-7 text-white" />
              </div>
              <h3 className="text-base sm:text-xl font-heading font-semibold text-[#292524] mb-1 sm:mb-2">
                {cat.title}
              </h3>
              <p className="text-xs sm:text-sm text-[#57534E] leading-snug sm:leading-relaxed line-clamp-2 sm:line-clamp-none">
                {cat.description}
              </p>
            </button>
          ))}
        </div>
      </div>
    </Layout>
  );
}
